export default __webpack_public_path__ + "maps-examples-show-hide-layer-1200-56e6ab7a77ef9f00b790aa34af92cdbf.png";